module.exports = __webpack_public_path__ + "static/img/logo_012.0646cc2f.png";